var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.7734H20V5.22656H0V15.7734ZM7.07031 6.98438C7.07031 6.76236 7.1962 6.55988 7.3941 6.46024C7.59216 6.36182 7.83127 6.38242 8.00751 6.51578L12.695 10.0314C12.8427 10.1417 12.9297 10.3157 12.9297 10.5C12.9297 10.6843 12.8427 10.8583 12.695 10.9686L8.00751 14.4842C7.90451 14.562 7.78091 14.6016 7.65625 14.6016C7.56699 14.6016 7.4765 14.581 7.3941 14.5398C7.1962 14.4401 7.07031 14.2376 7.07031 14.0156V6.98438Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 16.9453H14.1016V19.2891H10.5859V16.9453Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 16.9453H9.41406V19.2891H5.89844V16.9453Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 1.71094H15.2734V4.05469H20V3.46875C20 2.49951 19.2114 1.71094 18.2422 1.71094Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24219 8.15625V12.8438L11.3676 10.5L8.24219 8.15625Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 1.71094H9.41406V4.05469H5.89844V1.71094Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5312C0 18.5005 0.788574 19.2891 1.75781 19.2891H4.72656V16.9453H0V17.5312Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 1.71094H14.1016V4.05469H10.5859V1.71094Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2734 19.2891H18.2422C19.2114 19.2891 20 18.5005 20 17.5312V16.9453H15.2734V19.2891Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72656 1.71094H1.75781C0.788574 1.71094 0 2.49951 0 3.46875V4.05469H4.72656V1.71094Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedias);
export default __webpack_public_path__ + "static/media/ICON_MEDIAS.6dd7f9a0c14e7e71e1f36e329f03f936.svg";
export { ForwardRef as ReactComponent };